export default "__VITE_ASSET__oyRv9HDQ__"